import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'admin.users',
        path: `${APP_PREFIX_PATH}/admin/users`,
        component: React.lazy(() => import('views/app-views/admin/users')),
    },
    {
        key: 'user.profile',
        path: `${APP_PREFIX_PATH}/user/profile`,
        component: React.lazy(() => import('views/app-views/user/default')),
    },
    {
        key: 'user.update-password',
        path: `${APP_PREFIX_PATH}/user/update-password`,
        component: React.lazy(() => import('views/app-views/user/default')),
    },

    // ── Catálogo ──────────────────────────────────────────────
    {
        key: 'catalogo.lineas',
        path: `${APP_PREFIX_PATH}/lineas-negocio`,
        component: React.lazy(() => import('views/app-views/lineas-negocio')),
    },
    {
        // Detalle de Línea de Negocio con tabs (Datos / Categorías / Servicios).
        // Reemplaza las rutas standalone /categorias-servicio y /servicios.
        key: 'catalogo.lineas.detail',
        path: `${APP_PREFIX_PATH}/lineas-negocio/:id`,
        component: React.lazy(() => import('views/app-views/lineas-negocio/LineaDetail')),
    },

    // ── CRM ───────────────────────────────────────────────────
    // Staff y Calendario se renderizan ahora como tabs del detalle de la
    // línea spa (/lineas-negocio/:id). Los componentes en views/app-views/staff
    // y views/app-views/agenda se siguen importando desde LineaDetail, no
    // tienen ruta top-level.
    {
        key: 'crm.clientes',
        path: `${APP_PREFIX_PATH}/clientes`,
        component: React.lazy(() => import('views/app-views/clientes')),
    },
    {
        key: 'crm.socios',
        path: `${APP_PREFIX_PATH}/socios`,
        component: React.lazy(() => import('views/app-views/socios')),
    },
    {
        // Detalle del socio con tabs (Datos / Configuración por línea).
        // Reemplaza la ruta standalone /configuracion-socio-linea.
        key: 'crm.socios.detail',
        path: `${APP_PREFIX_PATH}/socios/:id`,
        component: React.lazy(() => import('views/app-views/socios/SocioDetail')),
    },

    // ── Promociones ───────────────────────────────────────────
    {
        key: 'promociones.cupones',
        path: `${APP_PREFIX_PATH}/cupones`,
        component: React.lazy(() => import('views/app-views/cupones')),
    },
    {
        key: 'promociones.qr-autoservicio',
        path: `${APP_PREFIX_PATH}/qr-autoservicio`,
        component: React.lazy(() => import('views/app-views/qr-autoservicio')),
    },
    {
        key: 'promociones.canjes',
        path: `${APP_PREFIX_PATH}/canjes`,
        component: React.lazy(() => import('views/app-views/canjes')),
    },
    {
        key: 'promociones.canjear',
        path: `${APP_PREFIX_PATH}/canjear`,
        component: React.lazy(() => import('views/app-views/canjear')),
    },
    {
        key: 'promociones.liquidaciones',
        path: `${APP_PREFIX_PATH}/liquidaciones`,
        component: React.lazy(() => import('views/app-views/liquidaciones')),
    },

    // ── Tienda online ─────────────────────────────────────────
    {
        key: 'tienda.productos',
        path: `${APP_PREFIX_PATH}/tienda/productos`,
        component: React.lazy(() => import('views/app-views/tienda/productos')),
    },
    {
        key: 'tienda.categorias',
        path: `${APP_PREFIX_PATH}/tienda/categorias`,
        component: React.lazy(() => import('views/app-views/tienda/categorias')),
    },
    {
        key: 'tienda.ventas',
        path: `${APP_PREFIX_PATH}/tienda/ventas`,
        component: React.lazy(() => import('views/app-views/tienda/ventas')),
    },
    {
        key: 'tienda.pagos',
        path: `${APP_PREFIX_PATH}/tienda/pagos`,
        component: React.lazy(() => import('views/app-views/tienda/pagos')),
    },

    // ── Web pública (home de la landing) ─────────────────────
    {
        key: 'web.textos',
        path: `${APP_PREFIX_PATH}/web/textos`,
        component: React.lazy(() => import('views/app-views/web/textos')),
    },
    {
        key: 'web.productos',
        path: `${APP_PREFIX_PATH}/web/productos`,
        component: React.lazy(() => import('views/app-views/web/productos')),
    },

    // ── Integraciones ─────────────────────────────────────────
    // Sync Timely se renderiza como tab del detalle de la línea spa
    // (/lineas-negocio/:id?tab=sync). El componente views/app-views/sync
    // se sigue importando desde LineaDetail.
]
